// extracted by mini-css-extract-plugin
module.exports = {"careerRecommendJobList__agentServiceWrapper":"careerRecommendJobList__agentServiceWrapper"};